<template>
    <div>
        <el-dialog :title="`${$t('AI量化')}-${info.invest}`" :visible.sync="dialogVisible" width="600px"
            :close-on-click-modal="false">
            <div class="dialog-box">
                <div class="cont txt-14">
                    <div class="top">
                        <div class="row row1">
                            <div class="img-div">
                                <img v-for="item in info.product_list" :src="item.image" :key="`${item.id}img`" />
                            </div>
                            <span>{{ info.invest }}</span>
                        </div>
                        <div class="row row2">
                            <label>{{ $t('使用人数') }}</label>
                            <label>{{ $t('跟随资金') }}</label>
                        </div>
                        <div class="row row3">
                            <span>{{ info.purchased_number || 0 }}</span>
                            <span> ₮ {{ info.follow_money || '0.00' }}</span>
                        </div>
                        <div class="row row4">
                            <div class="item" v-for="(item, index) in info.exercise_price" :key="index">
                                <label>{{ item.title }}</label>
                                <span>{{ item.profit }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="universal">
                        <div class="itemT">
                            <label>{{ $t('运行时长') }}</label>
                            <span>{{ info.days }}d</span>
                        </div>
                        <div class="itemT">
                            <label>{{ $t('区间最低价') }}</label>
                            <span>{{ info.amax }}</span>
                        </div>
                        <div class="itemT">
                            <label>{{ $t('最大收益率') }}</label>
                            <span>{{ info.rate }}%</span>
                        </div>
                        <div class="itemT">
                            <label>{{ $t('网格收益率') }}</label>
                            <span>{{ info.netrate }}%</span>
                        </div>
                        <div class="itemT">
                            <label>{{ $t('最大回撤率') }}</label>
                            <span>{{ info.ratemax }}%</span>
                        </div>
                        <div class="itemT">
                            <label>{{ $t('最大服务费') }}</label>
                            <span>{{ info.commission }}</span>
                        </div>
                    </div>

                    <div class="rich txt-14" v-if="info.rich_text">
                        <div class="title">{{ info.rich_text.title }}</div>
                        <img :src="info.rich_text.image" />
                        <div v-html="info.rich_text.content"></div>
                    </div>
                </div>
            </div>
            <div class="but" @click="dialogVisible1 = true">{{ $t('使用本策略') }}</div>
        </el-dialog>

        <el-dialog :title="$t('投资金额')" :visible.sync="dialogVisible1" width="500px" :close-on-click-modal="false">
            <div class="dialog-box" style="padding: 20px;">
                <div class="form-item">
                    <el-input v-model="amount" placeholder="" size="medium"> </el-input>
                </div>
                <div class="form-item" style="padding: 0px 20px;">
                    <el-slider v-model="slider" :marks="marks"></el-slider>
                </div>
                <div class="txt-div">
                    <label>{{ $t('当前余额') }}</label>
                    <span>{{ earnAccount }}</span>
                </div>
                <div class="but" @click="submit">{{ $t('确定') }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { get, post } from '@/http/request'
import apis from '@/http/api';
export default {
    props: {
    },
    data() {
        return {
            dialogVisible: false,
            dialogVisible1: false,
            info: {},

            earnAccount: '',

            amount: '0',
            slider: 0,
            marks: {
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%',
                // 75: {
                //   style: {
                //     color: '#1989FA'
                //   },
                //   label: this.$createElement('strong', '50%')
                // }
            }
        };
    },
    watch: {
    },
    created() {
    },
    methods: {
        open(id) {
            get(apis.aiInfo, { id }).then(res => {
                if (res.code != 1) return
                this.info = res.data

                this.dialogVisible = true
            })

            get(apis.getUserInfo, { showLoading: false }).then(res => {
                if (res.code != 1) return
                this.earnAccount = res.data.earn_account
            })
        },
        submit() {
            post(apis.aiSubmit, { id: this.info.id, amount: this.amount, }).then(res => {
                if (res.code != 1) return
                this.amount = '0'
                this.$notify.success(res.msg)

                this.dialogVisible1 = false
                this.dialogVisible = false
            })
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
    padding: 0px;
    padding-bottom: 20px;
}

::v-deep .el-dialog__header {
    .el-dialog__title {
        color: #fff;
    }

    padding-bottom: 15px;
    background-color: #1a222b;
}

::v-deep .el-slider {
    .el-slider__bar {
        background-color: #409eff;
    }

    .el-slider__button {
        border: 2px solid #409eff;
        background-color: #fff;
    }

    .el-slider__stop {
        background-color: #fff;
    }

    .el-slider__runway {
        background-color: #2e3244;
    }
}

.dialog-box {
    background-color: #12141e;
    padding: 40px;

    label {
        color: rgb(173, 173, 173);
    }

    .form-item {
        margin-bottom: 20px;
    }

    .txt-div {
        padding-top: 20px;
        margin-bottom: 50px;

        span {
            margin-left: 10px;
        }
    }

    .cont {
        // height: 380px;
        max-height: 60vh;
        overflow-y: auto;

        .rich {
            margin-top: 20px;

            .title {
                font-size: 16px;
            }

            img {
                margin: 20px auto;
            }
        }

        .universal {
            background-color: rgb(11, 11, 13);
            margin: 0px auto 20px;
            padding: 20px;
            border-radius: 8px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .itemT {
                width: 40%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                line-height: 20px;
                margin-bottom: 12px;
            }
        }

        .top {
            background-color: rgb(11, 11, 13);
            margin: 0px auto 20px;
            padding: 20px 0px 0px;
            border-radius: 8px;

            .row {
                display: flex;
                align-items: center;

                &.row4 {
                    .item {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        height: 80px;

                        label {
                            font-size: 12px;
                        }

                        span {
                            color: rgb(0, 240, 255);
                            font-size: 20px;
                            margin-top: 5px;
                        }
                    }
                }

                &.row3 {
                    span {
                        font-size: 20px;
                        line-height: 32px;
                        margin-top: 5px;
                        flex: 1;
                        text-align: center;
                    }
                }

                &.row2 {
                    background: rgb(26, 27, 36);
                    line-height: 50px;

                    label {
                        flex: 1;
                        text-align: center;
                    }
                }

                &.row1 {
                    display: flex;
                    flex-wrap: nowrap;
                    flex-direction: row;
                    justify-content: normal;
                    margin-bottom: 15px;
                    padding: 0px 30px;

                    .img-div {
                        img {
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;

                            &:not(:first-child) {
                                margin-left: -14px;
                            }
                        }
                    }

                    span {
                        margin-left: 10px;
                        height: 30px;
                        line-height: 30px;
                    }
                }
            }
        }
    }

}

.but {
    width: 350px;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    color: rgb(0, 0, 0);
    border-radius: 99px;
    background: rgb(0, 240, 255);
    text-align: center;
    cursor: pointer;
    margin: 20px auto 0px;
}
</style>